import { Injectable } from '@angular/core';

@Injectable()
export class LoaderService {

    showPreloader() {
        document.getElementById("restBodyLoader").setAttribute("style", "display:table;");
    }

    hidePreloader() {
        document.getElementById("restBodyLoader").setAttribute("style", "display:none;");
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/loader-service.ts